module.exports = __webpack_public_path__ + "img/statistics_hykh.1f6ea6aa.png";